import { SavedScatterPlotService } from 'Angular/features/components/saved-items/services/saved-scatter-plot.service';
import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { formFlattenedObject } from 'Angular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "Angular/features/components/saved-items/services/saved-scatter-plot.service";
export class ScatterPlotFolderableCollectionService extends FolderableCollectionLoadOnScrollServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        const dataParams = formFlattenedObject(this.dataParams, Object.keys(this.dataParams));
        return this.savedChartService.getFolderableItems(dataParams);
    }
    constructor(savedChartService) {
        super();
        this.savedChartService = savedChartService;
        this.scrollableBodyId = 'scatterPlotsTable';
    }
}
ScatterPlotFolderableCollectionService.ɵfac = function ScatterPlotFolderableCollectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotFolderableCollectionService)(i0.ɵɵinject(i1.SavedScatterPlotService)); };
ScatterPlotFolderableCollectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ScatterPlotFolderableCollectionService, factory: ScatterPlotFolderableCollectionService.ɵfac });
